import React from "react";

export class ComparisonHelper {
    static matchRight(matchArr, matchIdx, leftObj, rightArr) {
        if (undefined === matchArr[matchIdx]) {
            return rightArr[0];
        }

        const matchObj = matchArr[matchIdx];
        return this.matchRight(matchArr, matchIdx + 1, leftObj, rightArr
            .filter(rightObj => this.getFieldValue(matchObj.right.split("."), 0, rightObj) === this.getFieldValue(matchObj.left.split("."), 0, leftObj)));
    }

    static getFieldValue(fieldProperties, idx, obj) {
        const fieldProperty = fieldProperties[idx];
        if (undefined === fieldProperty || undefined === obj) {
            return obj;
        }

        if (Array.isArray(obj[fieldProperty])) {
            obj[fieldProperty] = obj[fieldProperty].slice();
        }
        else if ("object" === typeof obj[fieldProperty]) {
            obj[fieldProperty] = Object.assign({}, obj[fieldProperty]);
        }

        return this.getFieldValue(fieldProperties, idx + 1, obj[fieldProperty]);
    }

    static compareFields(fieldsArr, fieldIdx, leftObj, rightObj) {
        const fieldObj = fieldsArr[fieldIdx];

        if (undefined === fieldObj) {
            return leftObj;
        }

        const leftFieldProperties = fieldObj.left.split(".");
        const rightFieldProperties = fieldObj.right.split(".");

        const leftObjValue = this.getFieldValue(leftFieldProperties, 0, leftObj);
        const rightObjValue = this.getFieldValue(rightFieldProperties, 0, rightObj);

        const leftObjCompareValue = "function" === typeof fieldObj.leftParser ? fieldObj.leftParser(leftObjValue) : leftObjValue;
        const rightObjCompareValue = "function" === typeof fieldObj.rightParser ? fieldObj.rightParser(rightObjValue) : rightObjValue;

        if (leftObjCompareValue !== rightObjCompareValue) {
            let leftObjValueProperty = this.getFieldValue(leftFieldProperties.slice(0, leftFieldProperties.length - 1), 0, leftObj);
            if (leftObj === leftObjValueProperty) {
                leftObj[fieldObj.left] = {
                    left: leftObjValue,
                    right: rightObjValue
                };
            }
            else {
                leftObjValueProperty[leftFieldProperties[leftFieldProperties.length - 1]] = {
                    left: leftObjValue,
                    right: rightObjValue
                };
            }
        }

        return this.compareFields(fieldsArr, fieldIdx + 1, leftObj, rightObj);
    }

    static castRightToLeft(fieldsArr, fieldIdx, rightObj, outputObj) {
        const fieldObj = fieldsArr[fieldIdx];

        if (undefined === fieldObj) {
            return outputObj;
        }

        if (undefined !== outputObj) {
            let propertyToAdd = outputObj;
            const leftFieldProperties = fieldObj.left.split(".");
            for (let idx in leftFieldProperties) {
                if (undefined === propertyToAdd[leftFieldProperties[idx]]) {
                    propertyToAdd[leftFieldProperties[idx]] = {}
                }
                propertyToAdd = propertyToAdd[leftFieldProperties[idx]];
            }

            propertyToAdd.left = undefined;
            propertyToAdd.right = this.getFieldValue(fieldObj.right.split("."), 0, rightObj);
        }

        return this.castRightToLeft(fieldsArr, fieldIdx + 1, rightObj, outputObj);
    }

    // Comparison object struct to use the method
    // { match: [{left: "", right: ""}], fields: [{left: "", right: ""}] }
    static compare(leftArr, rightArr, comparisonObj) {
        const { match, fields } = Object.assign({ match: [], fields: [] }, comparisonObj);
        if (!Array.isArray(match) || !Array.isArray(fields)) {
            return leftArr.map(a => Object.assign({}, a));
        }

        const comparedArr = [];
        const rightArrObjectsFound = []

        for (let idx in leftArr) {
            const leftObj = Object.assign({}, leftArr[idx]);
            const rightObj = this.matchRight(match, 0, leftObj, rightArr);

            if (undefined === rightObj) {
                comparedArr.push(leftObj);
            }
            else {
                rightArrObjectsFound.push(rightObj);

                const obj = this.compareFields(fields, 0, leftObj, rightObj);
                if (undefined !== obj) {
                    comparedArr.push(obj);
                }
            }
        }

        for (let idx in rightArr) {
            const rightObj = rightArr[idx];
            if (undefined === rightArrObjectsFound.find(rf => rf === rightObj)) {
                let obj = this.castRightToLeft(match, 0, rightObj, {})
                obj = this.castRightToLeft(fields, 0, rightObj, obj);
                if (undefined !== obj) {
                    comparedArr.push(obj);
                }
            }
        }

        return comparedArr;
    }

    static renderLeftValue(value, callback) {
        if (undefined === value) {
            return "";
        }

        return (
            <span className="comparison-left-value">{callback(value)}</span>
        );
    }

    static renderRightValue(value, callback) {
        if (undefined === value) {
            return "";
        }

        return (
            <span className="comparison-right-value">{callback(value)}</span>
        );
    }

    static renderProperty(property, formatCallback = undefined) {
        let callback = (a) => a;
        if (undefined !== formatCallback && "function" === typeof formatCallback) {
            callback = (a) => formatCallback(a);
        }

        if (!Array.isArray(property) && "object" === typeof property && null !== property) {
            return (
                <React.Fragment>
                    {this.renderLeftValue(property.left, callback)}
                    {this.renderRightValue(property.right, callback)}
                </React.Fragment>
            );
        }

        return callback(property);
    }

    static getRowClass(keys) {
        let keysArr = keys;
        if (!Array.isArray(keys)) {
            if ("object" === typeof keys) {
                keysArr = [keys];
            }
            else {
                return "";
            }
        }

        for (let idx in keysArr) {
            const key = keysArr[idx];

            if (!"object" === typeof key) {
                return "";
            }

            if (undefined !== key.left) {
                return "";
            }
        }

        return "comparison-new-value";
    }
}



// WEBPACK FOOTER //
// ./src/components/helpers/ComparisonHelper.js